import type { SecodaEditorComponentProps } from '../types';
import Node from './Node';

export default abstract class ReactNode extends Node {
	abstract component(
		props: SecodaEditorComponentProps
	): React.ReactElement | null;
}
